import cx from 'classnames'
import { useContext } from 'react'

import { getPriceWithCurrency } from '@lib/format'
import { ShopContext } from '@lib/shop-context'
import { StringsContext } from '@lib/strings-context'

interface CartTotalProps {
  price: number
  className?: string
}

const CartTotal = ({ price, className }: CartTotalProps) => {
  const { currency, taxRate } = useContext(ShopContext)
  const strings = useContext(StringsContext)

  return (
    <div
      className={cx(
        'flex justify-between text-sm sm:text-base font-semibold',
        className,
      )}
    >
      <span>{strings.cartTotal}</span>
      <span className="uppercase">
        {getPriceWithCurrency(price, currency, {
          taxRate,
          thousandSeparator: ',',
        })}
      </span>
    </div>
  )
}

export default CartTotal
